import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const city = {
  path: '/requirements',
  component: Layout,
  name: 'requirement',
  redirect: '/requirements/index',
  children: [{
    path: '/requirements/index',
    component: () => import('@/views/requirements/index'),
    name: 'requirement.index',
    meta: {
      title: i18n.t(`message.requirement`)
    }
  }, ]
}

export default city